import React from 'react'
import { withIcon } from '../../withIcon'

function ArrowDownIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 4.12903C12.3563 4.12903 12.6452 4.41788 12.6452 4.77419V17.6682L17.7373 12.5761C17.9893 12.3241 18.3978 12.3241 18.6497 12.5761C18.9017 12.828 18.9017 13.2365 18.6497 13.4885L12.4562 19.682C12.2042 19.934 11.7958 19.934 11.5438 19.682L5.35025 13.4885C5.0983 13.2365 5.0983 12.828 5.35025 12.5761C5.6022 12.3241 6.0107 12.3241 6.26265 12.5761L11.3548 17.6682V4.77419C11.3548 4.41788 11.6437 4.12903 12 4.12903Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ArrowDownIcon)
